import { eventPeriodStatus, type EventPeriodStatus } from './eventListFilter';

/**
 * QA-356 — 팝업 관리(오프라인 팝업스토어) 검색 조건. 이벤트 관리와 같은 방식: BE 목록이 검색을 받지 않아
 * 전체를 받아 화면에서 거른다.
 */

export interface PopupListRow {
  popupId: string;
  name: string;
  location: string;
  openDate: string;
  closeDate: string;
  sortOrder: number;
  isActive: boolean;
}

export interface PopupListFilter {
  /** 팝업명·도시 부분일치(대소문자·앞뒤 공백 무시). */
  keyword: string;
  /** 기간 — 팝업 운영 기간이 이 범위와 겹치면 포함(yyyy-MM-dd, 비우면 제한 없음). */
  from: string;
  to: string;
  status: 'ALL' | EventPeriodStatus;
  active: 'ALL' | 'ACTIVE' | 'INACTIVE';
}

export const EMPTY_POPUP_FILTER: PopupListFilter = { keyword: '', from: '', to: '', status: 'ALL', active: 'ALL' };

export const filterPopups = <T extends PopupListRow>(rows: ReadonlyArray<T>, f: PopupListFilter, today: string): T[] => {
  const kw = f.keyword.trim().toLowerCase();
  return rows.filter((r) => {
    if (kw && !r.name.toLowerCase().includes(kw) && !(r.location ?? '').toLowerCase().includes(kw)) return false;
    if (f.from && r.closeDate && r.closeDate < f.from) return false;
    if (f.to && r.openDate && r.openDate > f.to) return false;
    if (f.status !== 'ALL' && eventPeriodStatus(r.openDate, r.closeDate, today) !== f.status) return false;
    if (f.active !== 'ALL' && r.isActive !== (f.active === 'ACTIVE')) return false;
    return true;
  });
};
